
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import SEO from 'global/SEO';
import { siteUrl } from 'constants/app';
import dynamic from 'next/dynamic';

const Financials = dynamic(() => import('features/pro-tools/Financials'));
const HomePageLayout = dynamic(() => import('global/HomePageLayout'));

function FinancialPage() {
  return (
    <HomePageLayout whiteFooterBackground>
      <SEO
        title="Stockbit - Financials Tools"
        description="Analisa laporan keuangan yang lengkap dengan tampilan yang menarik dan mudah dibaca untuk analisa saham. Periode Laporan. Pertumbuhan Perusahaan. Grafik Tren. Marjin Perusahaan. Analisa & Jual beli saham jadi lebih mudah."
        url={`${siteUrl}/info/pro-tools/financials`}
      />
      <Financials />
    </HomePageLayout>
  );
}

export default FinancialPage;
